import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { GetAuditRecordsInput, AuditRecordModel } from '../gql-types.generated';

export const QUERY_AUDIT_RECORD_BY_ID = gql`
  query auditRecordById($input: GetAuditRecordsInput!) {
    auditRecords(input: $input) {
      nodes {
        id
        createdTime
        entityId
        entityName
        entityState
        newValues
        oldValues
        userId
        userName
      }
    }
  }
`;

export const queryAuditRecordById = async (
    client: ApolloClient<NormalizedCacheObject>,
    id: string
): Promise<AuditRecordModel | undefined> => {
    const { data, errors } = await client.query({
        variables: {
            input: {
                id
            }
        },
        query: QUERY_AUDIT_RECORD_BY_ID,
    });

    if (errors && errors.length > 0) {
        errors.forEach(error => {
            console.error(error);
        });
        throw new Error('An error has occurred during the query.');
    }

    if (data?.auditRecords && data?.auditRecords.nodes && data?.auditRecords.nodes?.length > 0) {
        return data?.auditRecords?.nodes[0] as AuditRecordModel;
    }
    
    return undefined;
};
